var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardWriter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5361 65.1348L79.62 65.1348",
    stroke: "#5F4BEF",
    strokeWidth: 10.1816,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1524 61.6963L90.2038 52.2104L77.7822 49.0088L78.0198 58.3364L91.0523 65.9329L99.1524 61.7019V61.6963Z",
    fill: "#FF9E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0142 58.3423L78.6647 68.0318C78.7835 69.8136 80.6614 70.911 82.2678 70.1361L91.0523 65.9389L78.0198 58.3423H78.0142Z",
    fill: "#7A5FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 17.4687L98.3095 13.8032L77.7878 49.0147L99.158 61.6908L119.776 26.3097L110.612 17.4687H110.607Z",
    fill: "#FF9E1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.77 26.3152L98.3093 13.8031L101.828 7.76773C103.27 5.29586 106.46 4.45301 108.938 5.89541L121.422 13.1753C123.899 14.612 124.736 17.8079 123.294 20.2798L119.781 26.3096H119.776L119.77 26.3152Z",
    fill: "#FF7915"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.507 16.3262L86.9851 51.5377L92.6019 54.8637L113.22 19.4825L107.507 16.3206V16.3262Z",
    fill: "#FF7915"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWriter);
export default __webpack_public_path__ + "static/media/card_writer.70dcb5946d7d915009bf058986f86052.svg";
export { ForwardRef as ReactComponent };